import type { FileWithPath } from 'react-dropzone'

export const splitFolderPath = (file: Pick<FileWithPath, 'path'>) => {
  /**
   * Browser drop paths (FileSystemEntry.fullPath / webkitRelativePath) are spec-defined to
   * use '/' on every OS — never split on the host-OS separator. '\\' is only seen in
   * Electron absolute paths, so split on both.
   */
  const folderNames = file.path?.split(/[/\\]/).filter(Boolean) ?? []
  return { folder: folderNames.slice(0, -1).join('/'), filename: folderNames.at(-1) }
}

export const getUniqueFolders = (files: Pick<FileWithPath, 'path'>[]) => {
  const paths = files.map(splitFolderPath).map(p => p.folder)
  return [...new Set(paths)].filter(Boolean)
}
